import type { Translations } from "../keys.js";

export const zhHans = {
  eyebrow: "IBKR Activity Statement",
  title: "盈亏比报表分析",
  uploadMark: "Flex XML",
  uploadTitle: "拖入或选择 IBKR XML",
  uploadBody: "名称、账户、地址会在画面与本地分析中脱敏。",
  nfaDisclaimer: "仅供学习与交易复盘，不构成投资建议。",
  chooseFile: "选择文件",
  account: "账户",
  name: "名称",
  neutralName: "momo",
  period: "期间",
  baseCurrency: "基础货币",
  closed: "平仓",
  executions: "成交",
  netRealized: "净已实现",
  profitFactor: "Profit Factor",
  winRate: "胜率",
  payoffRatio: "盈亏比",
  expectancy: "期望值",
  executionRecords: "成交记录",
  canceledOrders: "取消委托",
  medianHoldingDays: "持仓中位数",
  commissionDrag: "佣金拖累",
  closedTradeSum: "逐笔平仓合计",
  grossProfitLoss: "总盈利 / 总亏损",
  averageWinLoss: "平均盈利 / 平均亏损",
  perClosedTrade: "每笔平仓平均",
  flexTradeRecords: "Flex XML 的 Trade 记录",
  flexCanceledRecords: "Flex XML 的 Order 取消记录",
  noCanceledRecords: "此 XML 未提供取消委托",
  holdingReview: "Holding",
  holdingReviewTitle: "交易持仓与盈亏比分析",
  holdingReviewHint: "按开平仓匹配后比较不同持仓周期的 PF、盈亏比与胜率。",
  holdingPeriod: "持仓周期",
  holdingIntraday: "日内",
  holdingSwing: "1-7 天",
  holdingPosition: "8-30 天",
  holdingLongTerm: "30 天以上",
  directionReview: "Direction",
  directionReviewTitle: "多空仓位分析",
  directionReviewHint: "按策略敞口拆分多头、空头与中性，检查哪一侧更有优势。",
  longPosition: "多头",
  shortPosition: "空头",
  neutralPosition: "中性",
  equityCurve: "Equity Curve",
  dailyRealized: "每日已实现损益",
  payoff: "Payoff",
  winLossDistribution: "盈亏分布",
  periodPerformance: "Period",
  periodHint: "绿柱为盈利，红柱为亏损；PF 与盈亏比请看下方表格。",
  weekly: "周度",
  monthly: "月度",
  periodColumn: "周期",
  monthColumn: "月份",
  realized: "已实现",
  pf: "PF",
  payoffShort: "盈亏比",
  trades: "笔数",
  assetBreakdown: "Assets",
  assetBreakdownTitle: "股票 / 期权统计",
  asset: "资产",
  medianPnl: "盈亏中位数",
  average: "平均",
  optionReview: "Options",
  optionReviewTitle: "期权标的复盘",
  underlying: "标的",
  date: "日期",
  dateCount: "日期数",
  daysShort: "天",
  hoursShort: "小时",
  minutesShort: "分",
  weakestSession: "最弱交易时段",
  intradaySessionNoData: "无常规盘平仓样本",
  intradaySessionTitle: "早午尾盘胜率分析",
  intradaySessionHint: "按平仓时间比较早盘、午盘、尾盘的已实现、中位数、平均每笔、PF、盈亏比与胜率。",
  weekdayReviewTitle: "星期几交易表现",
  weekdayReviewHint: "统计常规盘平仓与自动到期，按星期比较哪天盈亏比最好、哪天最差。",
  weekday: "星期",
  weekdaySunday: "星期日",
  weekdayMonday: "星期一",
  weekdayTuesday: "星期二",
  weekdayWednesday: "星期三",
  weekdayThursday: "星期四",
  weekdayFriday: "星期五",
  weekdaySaturday: "星期六",
  bestDay: "最好",
  worstDay: "最差",
  session: "时段",
  sessionMorning: "早盘",
  sessionMidday: "午盘",
  sessionLate: "尾盘",
  autoExpiry: "自动到期",
  optionLifecycle: "到期／结算",
  optionLifecycleRegularClose: "一般平仓",
  optionLifecycleEp: "到期失效",
  optionLifecycleEx: "行权",
  optionLifecycleA: "被指派",
  optionLifecycleCD: "现金结算",
  optionLifecycleAEx: "自动行权",
  optionLifecycleMEx: "手动行权",
  optionLifecycleGEA: "抵销到期／指派",
  discipline: "Discipline",
  disciplineRisk: "纪律风险",
  largeLossAlert: "大额亏损警示",
  largeLossDiscipline: "先停手，先守纪律",
  largeLossRule: "这一天的总亏损已超过本期风控门槛。复盘前不要加码追回，先确认原定止损、最大日亏与停手机制。",
  worstLossDay: "最大单日亏损",
  symbols: "Symbols",
  symbolPerformance: "标的排行榜",
  page: "页",
  previousPage: "上一页",
  nextPage: "下一页",
  offlineCoach: "Offline Coach",
  offlineAdvice: "离线建议",
  bestLoserWins: "Best Loser Wins",
  theme: "主题",
  language: "语言",
  dark: "深色",
  light: "浅色",
  stock: "股票",
  option: "期权",
  other: "其他",
  cash: "现金",
  future: "期货",
  unknown: "未知",
  winBucketSmall: "小赢",
  winBucketMedium: "中赢",
  winBucketLarge: "大赢",
  lossBucketSmall: "小亏",
  lossBucketMedium: "中亏",
  lossBucketLarge: "大亏",
  chartEmpty: "没有可绘制的平仓资料",
  dailyChartLegend: "柱状：每日，线条：累计",
  periodChartLegend: "PF 点：参考 1.00，上限",
  importFailed: "导入失败",
  profitStatus: "盈利",
  lossStatus: "亏损",
  flatStatus: "持平",
  costStatus: "成本",
  toggleDetails: "展开明细",
  "error.invalid_flex_xml": "请上传 IBKR Flex XML 文件。",
  "advice.profit_factor_below_one.title": "PF 低于 1，先处理亏损尾巴",
  "advice.profit_factor_below_one.body": "目前 PF {profitFactor}，代表总盈利还盖不住总亏损。下一步优先降低单笔大亏、到期归零与失控加仓，而不是增加交易次数。",
  "advice.profit_factor_thin_edge.title": "PF 有基础，但容错很薄",
  "advice.profit_factor_thin_edge.body": "目前 PF {profitFactor}。这种状态不是不能交易，而是不能让一两笔失控亏损吃掉整段成果。先定义单日最大亏损、最晚离场时间与停手机制。",
  "advice.profit_factor_healthy.title": "PF 结构相对健康",
  "advice.profit_factor_healthy.body": "目前 PF {profitFactor}。接下来不要盲目放大频率，应该找出哪些标的、时段与策略最稳，保留可重复的高质量交易。",
  "advice.winrate_and_payoff_weak.title": "胜率与盈亏比不能同时偏弱",
  "advice.winrate_and_payoff_weak.body": "胜率 {winRate}、盈亏比 {payoffRatio}。这代表你既没有足够命中率，也没有足够单笔收益补偿错误。进场前要更严格确认目标空间与止损距离。",
  "advice.high_winrate_weak_payoff.title": "胜率在补洞，但平均亏损仍偏重",
  "advice.high_winrate_weak_payoff.body": "胜率 {winRate} 还能支撑部分结果，但盈亏比 {payoffRatio} 代表一笔坏交易会吃掉多笔好交易。这通常不是看不准，而是离场与风险定义太松。",
  "advice.overtrade_loss_days.title": "亏损日有加速迹象",
  "advice.overtrade_loss_days.body": "{days} 天同时出现高交易数与负损益。这类日子要单独复盘第二笔以后的交易：它们是原计划，还是想把亏损追回来？",
  "advice.auto_expiry_losses.title": "自动到期不是噪声",
  "advice.auto_expiry_losses.body": "{count} 笔自动到期亏损已纳入。到期归零应该被视为可管理风险，而不是收盘前才处理的意外。建议写死“最晚离场时间”。",
  "advice.good_loser_base.title": "好的输家会保护下一笔交易",
  "advice.good_loser_base.body": "本期平均盈利 {avgWin}、平均亏损 {avgLoss}。亏损若在计划内，是交易成本；亏损若超出计划，就是风险定义需要收窄。",
  "advice.detach_outcome_from_ego.title": "把输赢从自尊里拿出来",
  "advice.detach_outcome_from_ego.body": "复盘时先问：这笔亏损是不是按计划发生？如果答案是肯定的，它只是成本；如果是否定的，它才是纪律问题。",
  "advice.large_tail_losses.title": "先让最大亏损变小",
  "advice.large_tail_losses.body": "{count} 笔亏损超过 {threshold}。改善 PF 最快的方式，通常不是提高胜率，而是砍掉会摧毁整周成果的尾部亏损。",
  "advice.asset_group_relative_edge.title": "{stronger} 目前相对更有优势",
  "advice.asset_group_relative_edge.body": "期权 PF {optionProfitFactor}、股票 PF {stockProfitFactor}。先把资金与注意力放在 PF 更稳的类别，再检查另一类是否只是偶发试单或情绪交易。",
  "advice.option_sample_dominant.title": "目前样本主要是期权",
  "advice.option_sample_dominant.body": "期权 PF {optionProfitFactor}、胜率 {optionWinRate}。请把到期、行权、最后交易时段与 IV 变化分开复盘，不要只看总盈亏。",
  "advice.stock_sample_dominant.title": "目前样本主要是股票",
  "advice.stock_sample_dominant.body": "股票 PF {stockProfitFactor}、胜率 {stockWinRate}。下一步应检查持仓时间、止损一致性与是否追高，而不是直接把股票结果和期权混在一起看。",
  "advice.weak_option_underlying_days.title": "期权弱势标的日期要单独复盘",
  "advice.weak_option_underlying_days.body": "{rows}。这些组合比总表更接近实际决策场景，应优先检查当天方向、入场时间与是否接近到期。",
  "advice.clean_sample.title": "先保持样本干净",
  "advice.clean_sample.body": "目前没有明显单一资产类别拖累。下一步可以累积更多样本，再看周期性、标的集中度与策略稳定性。",
} satisfies Translations;
